import { render, staticRenderFns } from "./ProPatientsCTestsPage.vue?vue&type=template&id=6eb10782"
import script from "./ProPatientsCTestsPage.vue?vue&type=script&lang=js"
export * from "./ProPatientsCTestsPage.vue?vue&type=script&lang=js"
import style0 from "./ProPatientsCTestsPage.vue?vue&type=style&index=0&id=6eb10782&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports